export const productData = [
	{
		code: "DCOC",
		name: "Cocoa OTC Trade",
		quantity: 956,
		bidPrice: 1872.4,
	},
	{
		code: "ACOC",
		name: "Sorghum OTC Trade",
		quantity: 1956,
		bidPrice: 1378.2,
	},
	{
		code: "BCOC",
		name: "Maize Fair Trade",
		quantity: 500,
		bidPrice: 1928.5,
	},
	{
		code: "ECOC",
		name: "Soyabeans Fair Trade ",
		quantity: 1256,
		bidPrice: 1420.7,
	},
	{
		code: "FCOC",
		name: "Coffee Fair Trade",
		quantity: 856,
		bidPrice: 1520,
	},
];

export const logData = [
	{
		security_code: "SMAZ",
		board: "Spot",
		price: 120000,
		lowest_price: 108000,
		location_code: "",
		highest_price: 132000,
		created: "2022-05-11T12:54:34.093046Z",
		transaction_fee_configurations: [
			{
				order_type: "Sell",
				fee_name: "Collateral Management",
				fee_description: null,
				fee_value: 0.7,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "Brokerage Fee",
				fee_description: null,
				fee_value: 0.75,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Brokerage Fee",
				fee_description: null,
				fee_value: 0.75,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0.3,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
		],
	},
	{
		security_code: "OPRL",
		board: "OTC",
		price: 150000,
		lowest_price: 135000,
		location_code: "",
		highest_price: 165000,
		created: "2022-05-11T15:41:22.470857Z",
		transaction_fee_configurations: [],
	},
	{
		security_code: "OSBS",
		board: "OTC",
		price: 150000,
		lowest_price: 148000,
		location_code: "",
		highest_price: 152000,
		created: "2021-09-20T11:14:26Z",
		transaction_fee_configurations: [],
	},
	{
		security_code: "DMAZ",
		board: "Spot",
		price: 210876.19,
		lowest_price: 192780,
		location_code: "281",
		highest_price: 235620,
		created: "2022-01-25T14:09:36.512280Z",
		transaction_fee_configurations: [
			{
				order_type: "Buy",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 1000,
				fee_type: "fixed",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 1000,
				fee_type: "fixed",
				fee_structure_type: "unit",
			},
		],
	},
	{
		security_code: "OCSN",
		board: "OTC",
		price: 1200000,
		lowest_price: 1080000,
		location_code: "021",
		highest_price: 1320000,
		created: "2022-06-15T11:42:22Z",
		transaction_fee_configurations: [],
	},
	{
		security_code: "DSBS",
		board: "Spot",
		price: 250000,
		lowest_price: 350000,
		location_code: "323",
		highest_price: 350000,
		created: "2022-06-24T12:48:22Z",
		transaction_fee_configurations: [
			{
				order_type: "Buy",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 1000,
				fee_type: "fixed",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 1000,
				fee_type: "fixed",
				fee_structure_type: "unit",
			},
		],
	},
	{
		security_code: "OMAZ",
		board: "OTC",
		price: 100000,
		lowest_price: 90000,
		location_code: "",
		highest_price: 110000,
		created: "2022-02-09T10:43:54.841435Z",
		transaction_fee_configurations: [],
	},
	{
		security_code: "SSBS",
		board: "Spot",
		price: 150,
		lowest_price: 135,
		location_code: "",
		highest_price: 165,
		created: "2022-02-09T16:20:15.362003Z",
		transaction_fee_configurations: [
			{
				order_type: "Sell",
				fee_name: "Collateral Management",
				fee_description: null,
				fee_value: 0.7,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0.3,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
		],
	},
	{
		security_code: "SSGM",
		board: "Spot",
		price: 180,
		lowest_price: 160,
		location_code: "",
		highest_price: 198,
		created: "2021-09-20T11:05:16Z",
		transaction_fee_configurations: [
			{
				order_type: "Sell",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Collateral Management",
				fee_description: null,
				fee_value: 0.7,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0.3,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
		],
	},
	{
		security_code: "SCOC",
		board: "Spot",
		price: 1200.29,
		lowest_price: 1080.26,
		location_code: "",
		highest_price: 1320.32,
		created: "2021-11-16T10:29:37Z",
		transaction_fee_configurations: [
			{
				order_type: "Sell",
				fee_name: "Collateral Management",
				fee_description: null,
				fee_value: 0.7,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "Exchange Fee",
				fee_description: null,
				fee_value: 0.5,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "SEC Fee",
				fee_description: null,
				fee_value: 0.3,
				fee_type: "percentage",
				fee_structure_type: "unit",
			},
			{
				order_type: "Buy",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
			{
				order_type: "Sell",
				fee_name: "VAT",
				fee_description: null,
				fee_value: 7.5,
				fee_type: "vat",
				fee_structure_type: "unit",
			},
		],
	},
];
